var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAledLogoWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2_00000125580210293914352270000001594198531628066455_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 85 49.7",
    style: {
      enableBackground: "new 0 0 85 49.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:white;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67.2,49.4V29.6c0.5-0.1,0.9-0.1,1.4-0.2c1.9-0.2,3.8-0.3,5.7-0.2c1.4,0,2.7,0.2,4,0.5c1.9,0.5,3.5,1.5,4.8,3 c0.9,1.1,1.5,2.5,1.7,3.9c0.3,1.8,0.3,3.7-0.2,5.5c-0.4,1.8-1.3,3.3-2.6,4.6c-0.9,0.9-2,1.5-3.2,1.9c-1.4,0.5-2.9,0.8-4.5,0.9 c-2,0.2-3.9,0.1-5.9-0.1C68,49.5,67.6,49.5,67.2,49.4L67.2,49.4z M71.8,32.8v13.2c0.1,0,0.2,0,0.3,0c1.2,0.1,2.3,0.1,3.5-0.2 c2.1-0.5,3.5-1.7,4.2-3.7c0.6-1.8,0.7-3.6,0.2-5.5c-0.5-2-1.8-3.2-3.8-3.8c-1-0.3-2.1-0.3-3.1-0.3C72.6,32.7,72.2,32.8,71.8,32.8 L71.8,32.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.6,33.1h-7.8v4.2h7.4V41h-7.4v4.8H64v3.7H51.2V29.4h12.4C63.6,29.4,63.6,33.1,63.6,33.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.5,29.4v16.3h8v3.8H35.9V29.4C36.2,29.3,39.6,29.3,40.5,29.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.6,12.7c-1.1-0.9-2.2-1.7-3.3-2.6c-4.2-3.3-8.4-6.6-12.6-9.9C42.5,0.1,42.3,0,42.1,0C28.2,0,14.4,0,0.6,0 C0.5,0,0.4,0,0.3,0C0.2,0,0.1,0,0,0c0,8.6,0,17.1,0,25.6c0,0.1,0,0.2,0,0.3c0,0,0,0,0,0c0,0,0,0,0,0h0.2c10.9,0,21.7,0,32.6,0 c3.1,0,6.2,0,9.2,0c0.2,0,0.4,0,0.5-0.2c2.3-1.8,4.6-3.6,6.9-5.4c2.5-2,5-3.9,7.5-5.9c0.6-0.5,1.2-1,1.9-1.5 C58.8,12.9,58.7,12.8,58.6,12.7L58.6,12.7z M36.3,22.9c-0.1-0.4-0.2-0.8-0.4-1.2c-0.4-1.2-0.7-2.5-1.1-3.7 c-0.1-0.3-0.1-0.3-0.4-0.3c-1.7,0-3.4,0-5.1,0c-0.4,0-0.4,0-0.5,0.4c-0.4,1.6-0.9,3.1-1.3,4.7c0,0,0,0.1,0,0.1h-4.7 c2-6.7,4.1-13.4,6.1-20.1h6c2.1,6.7,4.2,13.4,6.3,20.1L36.3,22.9L36.3,22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.8,6.1c0,0.1,0.1,0.2,0.1,0.3c0.6,2.6,1.4,5.2,2.2,7.9h-4.4C29.7,14.3,31.8,6.2,31.8,6.1L31.8,6.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAledLogoWeb);
export default __webpack_public_path__ + "static/media/aled-logo-web.2150a2a3107d04a4f2c8d15fb991359d.svg";
export { ForwardRef as ReactComponent };